/* web/style.css .sheet: in the side panel on desktop; a bottom sheet at phone width. */
.sheet { flex: 1; overflow-y: auto; animation: global(sheet-in) .25s var(--ease); pointer-events: auto; background: var(--surface); }
.leaving { animation: global(sheet-out) .18s ease-in forwards; }
.body { padding: 20px; }

@media (max-width: 760px) {
  .sheet {
    position: fixed; left: 0; right: 0; bottom: 0; z-index: 3; max-height: 58vh;
    border-radius: 28px 28px 0 0; box-shadow: 0 -2px 6px rgba(0, 0, 0, .04), 0 -8px 28px rgba(0, 0, 0, .14);
    animation-name: global(sheet-up); transition: max-height .25s var(--ease), transform .25s var(--ease);
  }
  .leaving { animation: global(sheet-down) .18s ease-in forwards; }
  .tall { max-height: 85vh; }
  /* The card opens as a peek (its header only); drag or tap it up for the full card. */
  .peek { max-height: 128px; overflow: hidden; }
  .peek .body { padding-top: 10px; }
  /* The Types list open: the card slides off the bottom and back (it keeps its stop). */
  :global(body.types-open) .sheet { transform: translateY(calc(100% + 24px)); }
}
